import * as React from "react"
import * as styles from "./styles.module.scss"
import Document from "components/Document"
import Footer from "components/Footer"
import Header from "components/Faq/Header"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import SideNav from "components/SideNav"
import Summary from "components/Faq/Summary"

export interface FaqProps {
  bare: boolean
}

const Faq: React.FC<FaqProps> = ({ bare }) => {
  return (
    <Document
      title="Frequently Asked Questions"
      description="Frequently asked questions. Learn about our rates, process, loan types and products, and servicing."
      pageId="Faq-summary"
      pageClass={styles.faq}
    >
      {!bare && (
        <>
          <Navbar getStartedType={GetStartedType.ALWAYS} />
          <SideNav />
        </>
      )}
      <PageWrapper paddingTop={PaddingTop.Navbar}>
        <main>
          <Header />
          <Summary bare={bare} />
        </main>
        {!bare && <Footer />}
      </PageWrapper>
    </Document>
  )
}

export default Faq
